<template>
  <div ref="wrap">
    <div ref="realBox" :style="pos" @mouseenter="enter" @mouseleave="leave">
      <div ref="slotList" :style="float">
        <slot></slot>
      </div>
      <div v-html="copyHtml" :style="float"></div>
    </div>
  </div>
</template>

<script>
require("utils/animationFrame")()
import { arrayEqual } from "utils/arrayEqual.js"
import { copyObj } from "utils/copyObj.js"
export default {
  name: "TableCore",
  data() {
    return {
      xPos: 0,
      yPos: 0,
      delay: 0,
      copyHtml: "",
      height: 0,
      width: 0, // 外容器宽度
      realBoxWidth: 0, // 内容实际宽度
      scrollPosition: 0,   //记录滚动位置，更新数据后从记录的位置开始滚动
      trLen: 1,
    }
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    classOption: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    leftSwitchState() {
      return this.xPos < 0
    },
    rightSwitchState() {
      return Math.abs(this.xPos) < this.realBoxWidth - this.width
    },
    float() {
      return this.isHorizontal ? { float: "left", overflow: "hidden" } : { overflow: "hidden" }
    },
    pos() {
      return {
        transform: `translate(${this.xPos}px,${this.yPos}px)`,
        transition: `all ${this.ease} ${this.delay}ms`,
        overflow: "hidden"
      }
    },
    defaultOption() {
      return {
        step: 1, //步长
        limitMoveNum: 1, //启动无缝滚动最小数据数
        hoverStop: false, //是否启用鼠标hover控制
        direction: 1, // 0 往下 1 往上 2向左 3向右
        singleHeight: 0, //单条数据高度有值hoverStop关闭
        singleWidth: 0, //单条数据宽度有值hoverStop关闭
        waitTime: 1000, //单步停止等待时间
        switchOffset: 30,
        autoPlay: false,
        navigation: false,
        switchSingleStep: 134,
        switchDelay: 400,
        isSingleRemUnit: false // singleWidth/singleHeight 是否开启rem度量
      }
    },
    options() {
      return copyObj({}, this.defaultOption, this.classOption)
    },
    navigation() {
      return this.options.navigation
    },
    autoPlay() {
      if (this.navigation) return false
      return this.options.autoPlay
    },
    scrollSwitch() {
      return this.data.length >= this.options.limitMoveNum
    },
    hoverStopSwitch() {
      return this.options.hoverStop && this.autoPlay && this.scrollSwitch
    },
    isHorizontal() {
      return this.options.direction > 1
    },
    baseFontSize() {
      return this.options.isSingleRemUnit
        ? parseInt(window.getComputedStyle(document.documentElement, null).fontSize)
        : 1
    },
    realSingleStopWidth() {
      return this.options.singleWidth * this.baseFontSize
    },
    realSingleStopHeight() {
      return this.options.singleHeight * this.baseFontSize
    },
    step() {
      let singleStep
      let step = this.options.step
      if (this.isHorizontal) {
        singleStep = this.realSingleStopWidth
      } else {
        singleStep = this.realSingleStopHeight
      }
      if (singleStep > 0 && singleStep % step > 0) {
        console.error("如果设置了单步滚动,step需是单步大小的约数,否则无法保证单步滚动结束的位置是否准确。~~~~~")
      }
      return step
    }
  },
  methods: {
    reset() {
      this.isHover = false
      this._cancle()
      this._initMove()
    },
    leftSwitchClick() {
      if (!this.leftSwitchState) return
      // 小于单步距离
      if (Math.abs(this.xPos) < this.options.switchSingleStep) {
        this.xPos = 0
        return
      }
      this.xPos += this.options.switchSingleStep
    },
    rightSwitchClick() {
      if (!this.rightSwitchState) return
      // 小于单步距离
      if (this.realBoxWidth - this.width + this.xPos < this.options.switchSingleStep) {
        this.xPos = this.width - this.realBoxWidth
        return
      }
      this.xPos -= this.options.switchSingleStep
    },
    _cancle() {
      cancelAnimationFrame(this.reqFrame || "")
    },
    enter() {
      if (this.hoverStopSwitch) this._stopMove()
    },
    leave() {
      if (this.hoverStopSwitch) this._startMove()
    },
    _move() {
      // 鼠标移入时拦截_move()
      if (this.isHover) return
      this._cancle() //进入move立即先清除动画 防止频繁touchMove导致多动画同时进行
      this.reqFrame = requestAnimationFrame(
        function () {
          const h = this.realBoxHeight / 2 //实际高度
          const w = this.realBoxWidth / 2 //宽度
          let { direction, waitTime } = this.options
          let { step } = this
          if (direction === 1) {
            let pageLen = this.data.length / this.trLen
            let num1 = (pageLen - 2) > 0 ? (pageLen - 2) : 0
            if(this.isBigScreenPreview() && Math.abs(this.yPos) === num1 * h / pageLen){
              //从上往下滚动，首先计算滚动位置，当滚动到实际高度时  请求下一页数据，计算最后一屏的位置
              console.log("当滚动到倒数第2屏时，请求下一页数据")
              this.$emit("requestNextPage")
              this.scrollPosition = this.yPos
            }
            // 上
            if (Math.abs(this.yPos) >= h) {
              this.$emit("ScrollEnd")
              this.yPos = 0
            }
            this.yPos -= step
          } else if (direction === 0) {
            // 下
            if (this.yPos >= 0) {
              this.$emit("ScrollEnd")
              this.yPos = h * -1
            }
            this.yPos += step
          } else if (direction === 2) {
            // 左
            if (Math.abs(this.xPos) >= w) {
              this.$emit("ScrollEnd")
              this.xPos = 0
            }
            this.xPos -= step
          } else if (direction === 3) {
            // 右
            if (this.xPos >= 0) {
              this.$emit("ScrollEnd")
              this.xPos = w * -1
            }
            this.xPos += step
          }
          if (this.singleWaitTime) clearTimeout(this.singleWaitTime)
          if (!!this.realSingleStopHeight) {
            //是否启动了单行暂停配置
            if (Math.abs(this.yPos) % this.realSingleStopHeight < step) {
              // 符合条件暂停waitTime
              this.singleWaitTime = setTimeout(() => {
                this._move()
              }, waitTime)
            } else {
              this._move()
            }
          } else if (!!this.realSingleStopWidth) {
            if (Math.abs(this.xPos) % this.realSingleStopWidth < step) {
              // 符合条件暂停waitTime
              this.singleWaitTime = setTimeout(() => {
                this._move()
              }, waitTime)
            } else {
              this._move()
            }
          } else {
            this._move()
          }
        }.bind(this)
      )
    },
    _initMove() {
      this.$nextTick(() => {
        const { switchDelay } = this.options
        const { autoPlay, isHorizontal } = this
        this.copyHtml = "" //清空copy
        if (isHorizontal) {
          this.height = this.$refs.wrap.offsetHeight
          this.width = this.$refs.wrap.offsetWidth
          let slotListWidth = this.$refs.slotList.offsetWidth
          // 水平滚动设置warp width
          if (autoPlay) {
            // 修正offsetWidth四舍五入
            slotListWidth = slotListWidth * 2 + 1
          }
          this.$refs.realBox.style.width = slotListWidth + "px"
          this.realBoxWidth = slotListWidth
        }

        if (autoPlay) {
          this.ease = "ease-in"
          this.delay = 0
          //根据记录的分页之前的数据记录位置来还原滚动的位置，从记录的位置开始滚动
          if(this.scrollPosition > 0){
            this.yPos = this.scrollPosition
          }
        } else {
          this.yPos = 0 // 还原位置
          this.ease = "linear"
          this.delay = switchDelay
          return
        }

        // 是否可以滚动判断
        if (this.scrollSwitch) {
          let timer
          if (timer) clearTimeout(timer)
          this.copyHtml = this.$refs.slotList.innerHTML
          setTimeout(() => {
            this.realBoxHeight = this.$refs.realBox.offsetHeight
            this._move()
          }, 0)
        } else {
          this._cancle()
          this.yPos = this.xPos = 0
        }
      })
    },
    _startMove() {
      this.isHover = false //开启_move
      this._move()
    },
    _stopMove() {
      this.isHover = true //关闭_move
      // 防止频频hover进出单步滚动,导致定时器乱掉
      if (this.singleWaitTime) clearTimeout(this.singleWaitTime)
      this._cancle()
    }
  },
  mounted() {
    this.trLen =  Math.round(this.classOption.tbodyHeight / this.realSingleStopHeight)
    this._initMove()
  },
  watch: {
    data(newData, oldData) {
      //监听data是否有变更
      if (!arrayEqual(newData, oldData)) {
        this.reset()
      }
    },
    autoPlay(bol) {
      if (bol) {
        this.reset()
      } else {
        this._stopMove()
      }
    }
  },
  beforeCreate() {
    this.reqFrame = null // move动画的animationFrame定时器
    this.singleWaitTime = null // single 单步滚动的定时器
    this.isHover = false // mouseenter mouseleave 控制this._move()的开关
    this.ease = "ease-in"
  },
  beforeDestroy() {
    this._cancle()
    clearTimeout(this.singleWaitTime)
  }
}
</script>
